import api from './api';

const merchantService = {
  // Dashboard
  getDashboard: () => api.get('/merchants/dashboard'),

  // Store management
  getMyStore: () => api.get('/merchants/my-store'),
  updateMyStore: (data) => api.put('/merchants/my-store', data),

  // Public
  listStores: (params) => api.get('/merchants', { params }),
  getStore: (slug) => api.get(`/merchants/store/${slug}`),
};

export default merchantService;
